module.exports = __webpack_public_path__ + "static/assets/d73e95d006d6529c479fe3b1d8c5fdb3.svg";